module.exports = __webpack_public_path__ + "static/media/logo-pragati.e8cf5fd4.png";